const defaultPallete = {
  neutral: '#fff',
};

export default defaultPallete;
